import { render } from "./TabNavigation.vue?vue&type=template&id=65875d76&scoped=true"
import script from "./TabNavigation.vue?vue&type=script&lang=js"
export * from "./TabNavigation.vue?vue&type=script&lang=js"

import "./TabNavigation.vue?vue&type=style&index=0&id=65875d76&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65875d76"]])

export default __exports__